import React from 'react';
import SweetAlert2 from 'react-sweetalert2';
import SweetAlertIcon from 'react-sweetalert2'

type SAlertIcon = 'warning' | 'error' | 'success' | 'info' | 'question'

interface Props {
  msg?: string,
  HtmlMsg?: any,
  show: boolean, 
  showDenyButton?: boolean,
  confirmBtnText?: string, 
  cancelBtnText?: string, 
  denyButtonText?: string,
  confirmBtnBsStyle?: string,
  cancelBtnBsStyle?: string, 
  denyBtnBsStyle?: string,
  title: string, 
  onConfirm: () => void,
  onCancel: () => void,
  onDeny?: () => void,
  showCancel?: boolean,
  icon?: SAlertIcon,
}
const SAlert: React.FC<Props> = ({
    msg, HtmlMsg, show, showDenyButton, confirmBtnText, cancelBtnText, denyButtonText, confirmBtnBsStyle, cancelBtnBsStyle, denyBtnBsStyle, title, onConfirm, onCancel, onDeny, showCancel, icon
}) => {
    return (
      <SweetAlert2
        show={show}
        icon={icon || 'warning'}
        showCancelButton={showCancel || false}
        showDenyButton={showDenyButton || false}
        allowOutsideClick={false}
        allowEscapeKey={false}
        confirmButtonText={confirmBtnText || 'Yes'}
        cancelButtonText={cancelBtnText || "No"}
        denyButtonText={denyButtonText || "Don't Save"}
        confirmButtonColor={confirmBtnBsStyle || 'primary'}
        cancelButtonColor={cancelBtnBsStyle || "secondary"}
        denyButtonColor={denyBtnBsStyle || "#898930ff"}
        title={title}
        text={msg}
        html={HtmlMsg}
        // onConfirm={onConfirm}
        onResolve={(result:any)=>{
            if (result.isDenied && onDeny) {
                onDeny();
            }
            if (result.isDismissed) {
                onCancel();
            }
            if (result.isConfirmed) {
                onConfirm();
            }
        }}
        onError={onCancel}
        focusCancel={false}
        backdrop={true}
      />
    );
}

export default SAlert;
